<app-form-input [parentForm]="parentForm" [value]="rectificatif.natureMarche.criteresAttrib" [label]="step3.getcriteresattrib"
    [type]="'text'" [rule]="'minSize_5|maxSize_2000'" [name]="getUidNatureMarche()+'_SepAtt_criteresAttrib'" [disabled]="disabled">
</app-form-input>
